var $globalHeader = $(".global-header");

$(function () {
	$("body").css({
		"--header-height": $globalHeader.outerHeight() + "px",
	});

	$(window).on("resize", function () {
		$("body").css({
			"--header-height": $globalHeader.outerHeight() + "px",
		});
	});

	$(window).on("scroll", function () {
		var scrollTop = window.pageYOffset || $(document).scrollTop();
		$globalHeader.toggleClass("scrolling", scrollTop > 0);
	});

	$globalHeader.on("sticky-end", function () {
		$("#sticky-wrapper").css({
			height: headerHeight,
		});
	});

	const menuMapping = new MappingListener({
		selector: ".menu-wrapper",
		mobileWrapper: ".menu-mobile-body",
		mobileMethod: "appendTo",
		desktopWrapper: ".language",
		desktopMethod: "insertBefore",
		breakpoint: 1024.98,
	}).watch();

	$(".close-menu-mobile, .menu-mobile-backdrop").on("click", function () {
		$(".menu-mobile").removeClass("show");
		$("body").removeClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeOut();
	});

	$(".menu-toggle").on("click", function () {
		$(".menu-mobile").addClass("show");
		$("body").addClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeIn();
	});

	$(".toggle-dropdown").on("click", function () {
		$(this).toggleClass("active");
		$(this).closest(".has-dropdown").find(".menu-dropdown").slideToggle();
	});
});
